import React, { useState, useEffect } from "react";
import Service from "../../Services/service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Audio } from 'react-loader-spinner';
import { ScreenGetByIdHooks } from "../../Helper/ScreenHelper";
import { LayoutListhooks } from "../../Helper/LayoutHelper";
import { CreateScreenHooks } from "../../Helper/ScreenHelper";

function CreateUserCompnent(props) {
    const navigate=useNavigate();
    const [layouts, setLayouts] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        userId: props.id,
        screenName: "",
        location: "",
        currentLayout: "",
    });

    async function fetchLayout() {
        try {
            
            const data = await LayoutListhooks("", "Name", false, 1, 1000);
            //  const data = await getLayout();

            if (data) {
                setLayouts(data.items);
            }

            const screendata = await ScreenGetByIdHooks(props.id);

            if (screendata) {
                setFormData((prevData) => ({
                    ...prevData,
                    ...screendata, // Corrected: Use screendata instead of data
                }));
                setIsEditing(true);
            }

        } catch (error) {
            console.error("Error fetching layout:", error);
        }
    }

    const handleLayout = (event) => {
        setFormData((prevData) => ({
            ...prevData,
            currentLayout: event.target.value, // Ensure it's a string
        }));
    };
    

    useEffect(() => {
        // fetchRole();
        if (props.id !== undefined) {
            fetchLayout();
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
            
            e.preventDefault();
            var res;
            res= await CreateScreenHooks(formData);
            if (res !== undefined) {
                toast.success(
                    props.id===undefined?
                    "Screen Created Successfully":
                    "Screen Updated Successfully"
                    , {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                
                if (props.id === undefined) {
                    setFormData({
                        userId: 0,
                        firstName: "",
                        lastName: "",
                        email: "",
                        passwordHash: "",
                        username: "",
                        roleId: 0,
                    });
                }
    
                setTimeout(() => {
                    navigate("/ScreenList");
                 }, 4000)
            } 
                else {
    
                toast.error("Failed to Update Screen. Please try again!", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }        
        };
    return (
        <div>
            <div className="container-fluid content-top-gap">
                <nav aria-label="breadcrumb" className="mb-4">
                    <ol className="breadcrumb my-breadcrumb">
                        <li className="breadcrumb-item">
                            <a href="/">Home</a>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            {props.id !== undefined ? "Edit Screen" : "Add Screen"}
                        </li>
                    </ol>
                </nav>

                <div className="accordions">
                    <div className="row">
                        <div className="col-lg-12 mb-4">
                            <div className="card card_border">
                                <div className="card-header chart-grid__header">
                                    {props.id !== undefined ? "Edit Screen" : "Add Screen"}
                                </div>
                                <div className="card-body">
                                    <div className="accordion" id="accordionExample">
                                        <div className="card">
                                            <div className="card-header " id="headingOne">
                                                <form onSubmit={handleSubmit}>
                                                    <div className="form-row">
                                                        <div className="form-group col-md-6">
                                                            <label htmlFor="screenName" className="input__label">
                                                                Screen Name
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control input-style"
                                                                id="screenName"
                                                                name="screenName"
                                                                placeholder="Screen Name"
                                                                onChange={handleChange}
                                                                value={formData.screenName}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="form-group col-md-6">
                                                            <label htmlFor="location" className="input__label">
                                                                Location
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control input-style"
                                                                id="location"
                                                                name="location"
                                                                placeholder="Location"
                                                                onChange={handleChange}
                                                                value={formData.location}
                                                                required
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="form-row">
                                                        <div className="form-group col-md-6">
                                                            <label htmlFor="Layout" className="input__label">
                                                                Layout
                                                            </label>
                                                            <select
                                                                id="Layout"
                                                                name="layout"
                                                                className="form-control input-style"
                                                                value={formData.currentLayout || ""}
                                                                onChange={handleLayout}
                                                                required
                                                            >
                                                                <option value="">Select Layout</option>
                                                                {layouts?.map((layout) => (
                                                                    <option key={layout.layoutId} value={layout.name}>
                                                                        {layout.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>


                                                    <button type="submit" className="btn btn-primary btn-style mt-4">
                                                        {props.id !== undefined ? "Edit Screen" : "Add User"}
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default CreateUserCompnent;
